module.exports = __webpack_public_path__ + "static/media/obinna.e293e51f.jpg";